import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Paper, Typography } from '@mui/material';
import processingVideo from "Assets/processing.mp4";
import IconStatCard from 'CommonComponents/IconStatCard';
import React, { useState } from 'react';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import DoriDonutChart from 'CommonComponents/DoriDonutChart';
import { buttonSelectedStyle } from 'HelperFiles/Constants';
import { buttonUnselectedStyle } from 'HelperFiles/Constants';
import { isSameDay } from 'HelperFiles/DashboardHelper';
import DoriStackedBarChart from 'CommonComponents/DoriStackedBarChart';
import { useDispatch, useSelector } from 'react-redux';
import { getSearchStartDate } from 'Redux/DashboardVariables';
import { getSearchEndDate } from 'Redux/DashboardVariables';
import Chart from "react-google-charts";
import VideojsPage from 'CommonComponents/VideojsPage';
import { getSelectedView } from 'Redux/DashboardVariables';
import { setSelectedView } from 'Redux/DashboardVariables';

const AllChartsComponents = ({
  allChartsData: {
    barChartData,
    pieChartData,
    timeLineData,
    videoData
  }
}) => {
  const dispatch = useDispatch();
  const searchStartDate = useSelector(getSearchStartDate);
  const searchEndDate = useSelector(getSearchEndDate);
  const selectedView = useSelector(getSelectedView);

  const [videoIndex, setVideoIndex] = useState(-1);
  const [openModal, setOpenModal] = useState(false);

  const handleClose1 = () => {
    setOpenModal(false);
  };

  const cardStyle1 = { padding: "4px 8px", boxShadow: "none" };

  let displayAvatar = (bgcolor, icon) => {
    return (
      <Avatar sx={{ bgcolor: bgcolor }} aria-label="recipe">
        {icon}
      </Avatar>
    );
  }
  const displayCard = (useCase, index) => {
    return (
      <Paper
        key={useCase.title}
        elevation={0}
        style={{
          padding: '1px 1px',
          background: "transparent",
          width: "33%",
          margin: '50px'
        }}
      >
        <IconStatCard
          title={useCase.title}
          subheader={useCase.subheader}
          body={useCase.body}
          footer={useCase.footer}
          cardStyle={useCase.cardStyle}
          avatar={useCase.avatar}
          footerButtonOnClick={useCase.footerButtonOnClick}
        />
      </Paper>
    );
  }
  let noPieChartData = displayCard(
    {
      title: "No Events",
      body: " ",
      cardStyle: cardStyle1,
      avatar: displayAvatar('orange', <AccessTimeFilledIcon />),
    }
  );

  let noChartData = displayCard(
    {
      title: "No Hourly/Daily Events",
      body: " ",
      cardStyle: cardStyle1,
      avatar: displayAvatar('orange', <AccessTimeFilledIcon />),
    }
  );

  let noTimelineEventsDisplay = displayCard(
    {
      title: "No Timeline Events",
      body: " ",
      cardStyle: cardStyle1,
      avatar: displayAvatar('orange', <AccessTimeFilledIcon />),
    }
  );

  const barChartEventsArr = [
    {
      eventName: "select",
      callback({ chartWrapper }) {
        // console.log('bar chart event: ', chartWrapper.getChart().getSelection());
      }
    }
  ];

  const timeLineChartEvents = [
    {
      eventName: "select",
      callback({ chartWrapper }) {
        let tempVideoIndex = chartWrapper.getChart().getSelection()[0].row;
        // Only enable playback of those events that have snippets
        console.log('on Click: ', tempVideoIndex, chartWrapper.getChart().getSelection(), videoData);
        if (videoData[tempVideoIndex].video !== "") {
          setVideoIndex(tempVideoIndex);
          setOpenModal(true);
        }

      }
    }
  ];

  // console.log('Pie chart data: ', pieChartData);

  return (
    <div style={{ width: '100%' }}>
      <div style={{
        fontFamily: 'Lato, sans-serif',
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginTop: '10px',
        marginLeft: '10px'
      }}>
        <span>Analytic Distribution</span>
      </div>
      {pieChartData.chartData && pieChartData.chartData.length ?
        <DoriDonutChart
          height='100%'
          width='100%'
          title=''
          chartData={pieChartData.chartData}
          chartColors={pieChartData.chartColors}
        />
        :
        <div style={{ display: 'flex', height: "100%", alignItems: "center", justifyContent: "center" }}>
          {noPieChartData}
        </div>

      }
      <Divider />
      <div style={{
        width: '100%',
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        marginTop: '10px',
        backgroundColor: 'white'
      }}>
        <Button
          size='small'
          style={selectedView === 'barchart'
            ? buttonSelectedStyle
            : buttonUnselectedStyle}
          onClick={() => dispatch(setSelectedView('barchart'))}
        >
          {
            isSameDay(searchStartDate, searchEndDate)
              ? 'Hourly View'
              : 'Daily View'
          }
        </Button>
        <Button
          size='small'
          style={selectedView === 'timelinechart'
            ? buttonSelectedStyle
            : buttonUnselectedStyle}
          onClick={() => dispatch(setSelectedView('timelinechart'))}
        >
          Timeline View
        </Button>
      </div>
      {
        selectedView === 'barchart'
          ?
          <Paper elevation={0} style={{
            overflow: 'hidden',
            padding: '10px 10px',
            height: '100%',
            fontSize: "12px",
            color: "#757575",
          }}>
            <div style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '14px',
              fontWeight: 'bold',
              textAlign: 'center'
            }}>
              <span>
                {
                  isSameDay(searchStartDate, searchEndDate)
                    ? 'Hourly Analysis'
                    : 'Daily Analysis'
                }
              </span>
            </div>
            {
              barChartData.chartData && barChartData.chartData.length
                ?
                <DoriStackedBarChart
                  chartEvents={barChartEventsArr}
                  barChartData={barChartData.chartData}
                  chartColors={barChartData.chartColors}
                />
                :
                <div style={{
                  display: 'flex',
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  {noChartData}
                </div>
            }
          </Paper>
          :
          <Paper elevation={0} style={{
            width: '100%',
            height: '100%',
            fontSize: "12px",
            color: "#757575",
          }}>
            <div style={{
              display: 'flex',
              fontFamily: 'Lato, sans-serif',
              fontSize: '14px',
              marginBottom: '10px',
              padding: '10px 0 0 10px'
            }}>
              <span>
                Timeline Distribution
              </span>&nbsp;
              <span style={{ fontStyle: 'italic', fontWeight: 'normal' }}>(scroll down for more cameras)</span>
            </div>
            {
              timeLineData && timeLineData.length ?
                <Chart
                  chartEvents={timeLineChartEvents}
                  chartType="Timeline"
                  data={timeLineData}
                  height="35vh"
                  options={{
                    tooltip: { isHtml: true },
                    hAxis: {
                      format: "MMM d, y HH:mm:ss",
                    },
                    timeline: { showRowLabels: false }
                  }}
                />
                :
                <div style={{ display: 'flex', height: "100%", alignItems: "center", justifyContent: "center" }}>
                  {noTimelineEventsDisplay}
                </div>
            }
          </Paper>
      }
      <Dialog
        fullWidth={false}
        maxWidth={"md"}
        open={openModal}
        onClose={handleClose1}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose1}>
          {/* {selectedData ? selectedData.incidentType : ""} */}
          <span
            style={{ textTransform: "inherit!important", color: "#e40000" }}
          >
            {videoIndex !== -1 && videoData[videoIndex]
              ? videoData[videoIndex].incidentLocation +
              " - " +
              videoData[videoIndex].incidentCamera +
              " - " +
              videoData[videoIndex].incidentType
              : ""}
          </span>
        </DialogTitle>
        <DialogContent dividers style={{ background: "black" }}>
          <VideojsPage
            src={
              videoIndex !== -1 &&
                videoData[videoIndex] &&
                videoData[videoIndex].video
                ? videoData[videoIndex].video
                : processingVideo
            }
            height="auto"
            width="100%"
          />
        </DialogContent>

        <DialogActions
          style={{ justifyContent: "space-around" }}
        >
          <Typography style={{ marginRight: "20px" }}>
            {videoIndex !== -1 && videoData[videoIndex]
              ? new Date(videoData[videoIndex].incidentTime).toString()
              : ""}
          </Typography>

          <Button
            variant="contained"
            style={{ background: "#e40000", textTransform: 'none' }}
            color="primary"
            onClick={handleClose1}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AllChartsComponents;
